

// This enum is used for all the transaction response status we get.
export enum ResultStatus {
  NoProcess = 0,
  Failure = 1,
  Abort = 2,
  Cancel = 3,
  Warning = 4,
  Information = 5,
  NoData = 6,
  Validation = 7,
  Success = 8,
}
export enum responseMessageStatus {
  info = 'info',
  warning = 'warning',
  success = 'success',
  error = 'error',
}
export enum ResponseStatus {
  success = 1,
  error = 0,
}

export enum FAQSection {
  PAYMENTPROCESSINGFAQ = 1,
  PREMIUMCONTENTPROGRAMFAQ = 2,
}

export enum ActivityType {
  OutstandingInvoice = 2,
  CompletedTransactions = 3,
}

export enum ContentType {
  Premium = 0,
  Standard = 1,
}

export enum BrooklynInvestmentStatus {
  PendingApproval = 1,
  UnderReview = 2,
  Processing = 3,
  EstimateSent = 4,
  Completed = 5,
  CancellationUnderReview = 6,
  canceled = 7,
  InvoiceSent = 8,
  InvoicePaid = 9,
  Voided = 10,
  Deleted = 11,
}
export enum TransactionsType {
  StartingBalance = 0,
  Investment = 1,
  Payment = 2,
  Transfer = 3,
  Expenses = 4,
  InternalTransfer = 5,
  Refunds = 6,
  Credits = 7,
  Deposits = 8,
}
export enum TransactionsSubType {
  InvoicePaid = 1,
  Payments = 2,
  Transfers = 3,
  Canceled = 4,
}

export enum CustomerType {
  QboCustomer = 0,
  SiteCustomer = 1,
  RetailCustomer = 2
}

export enum BrooklynBillStatus {
  PendingApproval = 1,
  Processing = 2,
  Payment = 3,
  CancellationUnderReview = 4,
  canceled = 5,
  UnderReview = 6,
  Voided = 7,
}
export enum PaybevPaymentStatus {
  Schedule = 1,
  CancellationUnderReview = 2,
  canceled = 3,
  UnderReview = 4,
  Voided = 5,
}
// here you need to define the role which you have in project
export enum UserType {
  User = 0,
  Admin = 1,
  SuperAdmin = 2,
  Vendor = 3,
  None = 4,
  SuperTenantAdmin = 5,
}

export enum PaybevStageStatus {
  Scheduled = 1,
  PendingApproval = 2,
}

export enum PdfFileEditAction {
  View = 1,
  Rotate = 2,
  Delete = 3,
}

export enum ServiceType {
  Standard = 1,
  NextDay = 2,
}

export enum contentType {
  ResquestSend = 1,
  DonateCore = 2,
  Reports = 3,
}

export enum AssignmentUser {
  projectManager = 0,
  director = 1,
  accountManager = 2,
  executive = 3,
  seniorAccountManager = 4,
  financeManager = 5,
}

export enum PaybevInvestmentStatus {
  Confirmed = 1,
  NeedsConfirmation = 2,
  UnderReview = 3,
  Rejected = 4,
  EditDate = 5,
  CancellationUnderReview = 6,
  PastDue = 7,
  Blank = 8,
}

export enum RetailProgramInvestmentStatus {
  Pending = 0,
  Processing = 1,
  Active = 2,
  ExpiringSoon = 3,
  Expired = 4,
  Unpurchased = 5,
  InvoiceSent = 6,
  EstimateSent = 7,
  Voided = 8
}

export enum ContentTab {
  Standard = 0,
  Premium = 1,
}

export enum BalanceTransferStatus {
  Processing = 1,
  InvoiceSent = 2,
  InvoicePaid = 3,
  Voided = 4,
}

export enum EndPoints {
  Login = 'Authenticate/Login',
  Register = 'Authenticate/Register',

  uploadFile = 'Generic/UploadFile',
  deleteFile = 'Generic/DeleteFile',

  GetUsers = 'User/GetRecords',
  GetAccountSupplierAndSupplierBank = 'User/GetAccountSupplierAndSupplierBank',

  GetPaybevUserDetails = 'User/GetPaybevUserDetails',
  GetRoles = 'User/GetRoles',
  AddUser = 'User/CreateUser',
  EditUser = 'User/UpdateUser',
  GetUserAccountsSites = 'User/GetUserAccountsSites',
  GetUserAgencies = 'User/GetUserAgencies',
  UpdateUserProfile = 'User/UpdateUserProfile',
  UploadProfilePicture = 'User/ProfilePicture',
  GetSuppliersForUser = 'Investors/GetSuppliersForUser',
  GetSiteService = 'Sites/GetSiteService',

  UpdateProfileData = 'User/ProfileUpdate',
  MyAgreements = 'TermsAcceptance/MyAgreements',
  MyAgreement = 'TermsAcceptance/MyAgreement',
  TermsPolicy = 'TermsAcceptance/Policy',
  PasskeyList = 'Passkey/list',
  PasskeyRevoke = 'Passkey',
  DeviceList = 'Device/list',
  DeviceRevoke = 'Device',
  // My Profile: a new mobile number only replaces the old one once a code texted to it is verified.
  PhoneChangeSend = 'PhoneChange/send',
  PhoneChangeResend = 'PhoneChange/resend',
  PhoneChangeVerify = 'PhoneChange/verify',

  GetSiteNonAlcBalance = 'Sites/GetSiteNonAlcBalance',

  PreviewQBOAttachment = 'Payments/PreviewQBOAttachment',

  DeleteUser = 'User/DeleteRecord',
  SendAccountVerifyOTP = 'Authenticate/SendAccountVerifyOTP',

  PayBevAutoLogin = 'Authenticate/SsoLogin',
  LogOut = 'Authenticate/LogOut',

  GetNotificationDetails = 'User/GetNotificationDetails',
  UpdateNotificationRecord = 'User/UpdateSupplierNotificationRecord',
  UserSites = 'User/GetUserSites',
  GetRecordById = 'User/GetRecordById',
  GetAssignmentAndAgreementDate = 'User/GetAssignmentAndAgreementDate',

  GetSiteAndAgencyDetails = 'Authenticate/SiteLogin',
  ForgotPassword = 'Authenticate/ForgotPassword',
  ResetPassword = 'Authenticate/ResetPassword',
  GetAllPrograms = 'Program/GetAll',
  DeleteProgram = 'Program/Delete',
  makeProgramDefault = 'Program/UpdateDefault',
  UpdatePorgramVisible = 'Program/UpdateVisible',
  GetVendorDropdownList = 'Vendor/GetSiteVendorDropdownList',
  GetVendorDetails = 'Vendor/GetSiteVendor',

  GetAllAddedInvestors = 'Investors/GetRecords',
  DeleteInvestor = 'Investors/DeleteInvestor',
  GetDBInvestors = 'Investors/SearchInDatabase',
  AddInvestorFromDB = 'Investors/AddInvestorFromDatabase',
  GetAllTags = 'Tag/GetAll',
  AddTagGroup = 'Tag/Add',
  UpdateTagGroup = 'Tag/Update',
  DeleteTagGroup = 'Tag/Delete',
  GetTagGroupName = 'Tag/GetTagGroupName',
  AddTag = 'Tag/AddTag',
  UpdateTag = 'Tag/UpdateTag',
  DeleteTag = 'Tag/DeleteTag',
  GetTagsDropdownlist = 'Tag/GetTagsDropdownlist',

  GetInvestorsBySite = 'Investors/GetInvestorBySite',
  GetInvestorDetails = 'Investors/GetInvestorDetails',
  GetInvestorTerms = 'Investors/GetInvestorTerms',
  GetInvestmentDescription = 'Investments/GetInvestmentDescription',
  GetAllInvestments = 'Investments/GetInvestments',
  GetInvestmentById = 'SupplierPortal/GetSupplierInvestment',
  GetInvestor = 'Investors/GetInvestor',

  GetRefund = 'Refunds/GetRefundsById',

  ScheduleInvestment = 'Investments/ScheduleInvestment',
  UpdateInvestment = 'Investments/UpdateInvestment',
  SaveInvestment = 'Investments/SaveInvestment',
  ConfirmInvestment = 'Investments/ConfirmInvestment',
  CancelInvestment = 'Investments/CancelInvestment',
  EditInvestmentRequest = 'Investments/EditInvestmentRequest',
  DeleteInvestment = 'Investments/DeleteInvestment',
  UpdateProgramToStartingBalTransaction = 'Investments/UpdateProgramToStartingBalTransaction',
  GetStartingBalanceDetails = 'Investments/GetStartingBalanceDetails',

  EditPDFFiles = 'Payments/EditPdfFiles',
  SchedulePayment = 'Payments/SchedulePayment',
  GetPayment = 'Payments/GetPayment',
  UpdatePayment = 'Payments/UpdatePayment',
  CancelPayment = 'Payments/CancelPayment',
  DeletePayment = 'Payments/DeletePayment',

  GetExpense = 'Payments/GetExpense',
  UpdateExpense = 'Payments/UpdateExpense',

  GetCredit = 'Credits/GetCreditsById',
  UpdateCredit = 'Credits/UpdateCredits',
  UpdateDeposit = 'Deposits/UpdateDeposits',
  UpdateRefund = 'Refunds/UpdateRefunds',

  GetInternalTransfer = 'Transfers/GetInternalTransfer',
  GetDeposit = 'Deposits/GetDepositsById',

  UpdateInternalTransfer = 'Transfers/UpdateInternalTransfer',

  GetProgramBySite = 'Program/GetProgrameBySite',

  GetActivities = 'Activity/GetActivitys',
  GetActivitiesV2 = 'SupplierPortal/GetSupplierActivities',
  GetPrintDetails = 'Activity/GetPrintDetailLink',
  ContactInvestor = 'Activity/ContactInvestor',
  GetSupplierActivitiesFilter = 'SupplierPortal/GetSupplierActivitiesFilter',

  //get activity accounts
  GetActivityCounts = 'Activity/GetActivityCounts',
  GetActivitiesCounts = 'Activity/GetActivitiesCounts',

  GetInvestmentHistory = 'Investors/GetInvestmentHistory',

  GetSummary = 'SupplierPortal/GetSupplierSummary',

  GetResourceRecords = 'PayBevResource/GetResourceRecords',

  GetLast24Months = 'Reports/GetLast24MonthsTransactionDetails',
  GetAccountStatements = 'Reports/AccountStatements',
  GetOutstandingInvoices = 'Reports/OustandingInvoices',
  // GetActivityExport = 'Reports/ActivityExport',
  // GetActivityExport = 'Reports/ActivityExcelExport',
  GetActivityExport = 'SupplierPortal/SupplierActivityExcelExportV2',

  //get announcements
  GetAnnouncement = 'Sites/GetAnnouncement',
  UpdateSeenAnnouncement = 'Sites/UpdateSeenAnnouncement',
  ChangePassword = 'Authenticate/ChangePassword',
  // Security > Password: emails the signed-in caller their own reset link. Takes no body — the
  // account and the portal both come from the JWT.
  SendPasswordResetLink = 'Authenticate/password/reset-link',

  //maintenance
  GetMaintainanceStatus = '/Authenticate/GetMaintainanceStatus',

  GetInvoiceURL = 'Transactions/GetSummaryURI',

  //programs
  GetProgramProfile = 'Program/GetProgramProfile',
  GetSupplierPrograms = 'RetailProgram/GetRetailProgramsByUserAndSupplierId',
  GetStandardContent = 'RetailProgram/GetStandardContent',
  GetPremiumContent = 'RetailProgram/GetPremiumContent',
  GetSiteDetailsById = 'Sites/GetSiteDetailsById',
  GetRetailProgramById = 'RetailProgram/GetRetailProgramById',
  GetSupplierInvestors = 'Investors/GetSupplierInvestors',
  AddRep = 'Reps/AddRep',

  //registration
  GetCompanyName = 'SupplierPortal/GetCompanyName',

  //brands
  GetBrandsForFilter = 'RetailProgram/GetBrandsForFilter',
  GetPremiumContentFilter = 'RetailProgram/GetPremiumContentFilter',
  RenewRetailProgramInvestment = 'RetailProgram/RenewRetailProgramInvestment',

  GetStandardContentFilters = 'RetailProgram/GetStandardContentFilter',

  //faqs
  GetFAQList = 'ContentManager/GetFAQ',


  //content manager
  AddRetailProgramInvestment = 'RetailProgram/RetailProgramInvestment',
  UpdateRetailProgramInvestment = 'RetailProgram/UpdateRetailProgramInvestment',

  GetContentManager = 'ContentManager/GetContentManager',
  AddContentManager = 'ContentManager/AddContentManager',
  UpdateContentManager = 'ContentManager/UpdateContentManager',
  DeleteContentManager = 'ContentManager/DeleteContentManager',

  //brands
  DeleteRetailProgramInvestment = 'RetailProgram/DeleteRetailProgramInvestment',
  GetBrandReportPdf = 'RetailProgram/GetBrandReportPdf',
  DownloadAllBrandReports = 'RetailProgram/DownloadAllBrandReports',
}

export const AuthEndpoints = {
  Login: 'Authenticate/Login',
  LoginStart: 'Authenticate/login/start',
  LoginPassword: 'Authenticate/login/password',
  Refresh: 'Authenticate/Refresh',
  SendAccountVerifyOTP: 'Authenticate/SendAccountVerifyOTP',
  // Terms sign-off: the last gate of a sign-in. Anonymous — the caller holds a terms token, not a JWT.
  TermsPending: 'TermsAcceptance/Pending',
  TermsAccept: 'TermsAcceptance/Accept',
  TermsPolicy: 'TermsAcceptance/Policy',
  MfaSend: 'Mfa/Send',
  MfaVerify: 'Mfa/Verify',
  MfaPhoneSend: 'Mfa/phone/send',
  MfaPhoneVerify: 'Mfa/phone/verify',
  PasskeyRegisterOptions: 'Passkey/register/options',
  PasskeyRegisterComplete: 'Passkey/register/complete',
  PasskeyLoginOptions: 'Passkey/login/options',
  PasskeyLoginComplete: 'Passkey/login/complete',
  PasskeyList: 'Passkey/list',
  PasskeyRevoke: 'Passkey',
  PasskeySnooze: 'Passkey/prompt/snooze',
  DeviceList: 'Device/list',
  DeviceRevoke: 'Device',
  ActivationStatus: 'Activation/status',
  ActivationVerifyIdentity: 'Activation/verify-identity',
  ActivationVerifyPhone: 'Activation/verify-phone',
  ActivationVerifyEmail: 'Activation/verify-email',
  ActivationResend: 'Activation/resend',
  ActivationSetPassword: 'Activation/set-password',
  ActivationPasskeyOptions: 'Activation/passkey/options',
  ActivationPasskeyComplete: 'Activation/passkey/complete',
  PayBevAutoLogin: 'Authenticate/SsoLogin',
  LogOut: 'Authenticate/LogOut',
  GetSiteAndAgencyDetails: 'Authenticate/SiteLogin',
  ForgotPassword: 'Authenticate/ForgotPassword',
  ResetPassword: 'Authenticate/ResetPassword',
  VerifyTokenToResetPassword: 'Account/verifytoken',
  ChnagePassword: 'User/changepassword',
  ChangePassword: 'Authenticate/ChangePassword',
  GetMaintainanceStatus: '/Authenticate/GetMaintainanceStatus',
  SsoHandoff: 'Authenticate/sso/handoff',
} as const;
